import { ref } from 'vue'

const createMaterialsFilters = () => ({
    name: null,
    materialIndex: null,
    isVisible: true
})

const createPapersFilters = () => ({
    name: null,
    group_id: null,
    isVisible: true
})

const createPaperGroupsFilters = () => ({
    name: null,
    isVisible: true
})

const createPaginationMeta = () => ({
    count: 0,
    current: 1,
    next: null,
    previous: null
})

export function createMaterialsState() {
    return {
        // Materials
        materials: ref([]),
        materialsLoading: ref(false),
        materialsFilters: ref(createMaterialsFilters()),
        materialsMeta: ref(createPaginationMeta()),
        materialTypes: ref([]),
        unitsOfMeasure: ref([]),
        productProductionProperties: ref([]),

        // Papers
        papers: ref([]),
        papersLoading: ref(false),
        papersFilters: ref(createPapersFilters()),
        papersMeta: ref(createPaginationMeta()),
        coatingTypes: ref([]),
        prinergyPaperTypes: ref([]),

        // Paper groups
        paperGroups: ref([]),
        paperGroupsLoading: ref(false),
        paperGroupsFilters: ref(createPaperGroupsFilters()),
        paperGroupsMeta: ref(createPaginationMeta()),

        // File import helpers
        importProgress: ref(0),
        importInProgress: ref(false),
        importAbortController: ref(null),

        // Factories
        createMaterialsFilters,
        createPapersFilters,
        createPaperGroupsFilters,
        createPaginationMeta
    }
}
